/**
 * Format a tool name for display.
 * Converts snake_case and camelCase to readable format.
 * Examples:
 *   - "search_video" → "search video"
 *   - "searchVideo" → "search Video"
 *   - "search_Video_HD" → "search Video HD"
 *   - "HTMLParser" → "HTML Parser"
 */
export function formatToolName(toolName: string): string {
    return toolName
        .replace(/_/g, ' ')
        .replace(/([a-z])([A-Z])/g, '$1 $2')
        .replace(/([A-Z]+)([A-Z][a-z])/g, '$1 $2')
        .replace(/\s+/g, ' ')
        .trim();
}
